export const getOriginPath = () => {
  const originPath = process.env.VUE_APP_BACKEND_URL || window.location.origin;
  return originPath;
};
